import { WarehouseGoodUsageStatus } from '../enums/warehouse-good-usage-status';
import { WarehouseGoodConnectedObject } from './warehouse-good-connected-object';

export class WarehouseGoodUsage {
  public constructor(
    private readonly data: {
      status: WarehouseGoodUsageStatus;
      connectedObjects: WarehouseGoodConnectedObject[];
    },
  ) {}

  public get status(): WarehouseGoodUsageStatus {
    return this.data.status;
  }

  public get connectedObjects(): WarehouseGoodConnectedObject[] {
    return this.data.connectedObjects;
  }
}
